import { BillingQuoteStatus } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';

export const transitionBillingQuote = async (
  quoteId: string,
  to: BillingQuoteStatus,
  expectedEditVersion?: number
) => {
  const response = await fetcher(
    `commenda-billing/quotes/${quoteId}/transition`,
    {
      method: 'POST',
      body: { to, expectedEditVersion },
    }
  );

  return response;
};
